import Footer from "../components/templates/Footer";
import ic_faq_image_banner from "../assets/ic_faq_image_banner.svg";
import Label from "../components/atoms/Label";
import "../styles/FAQPage.css";
import ic_fb from "../assets/ic_fb.svg";
import ic_insta from "../assets/ic_insta.svg";
import ic_linkedin from "../assets/ic_linkedin_green.svg";
import ic_youtube from "../assets/ic_youtube.svg";
import Accordion from '@mui/material/Accordion';
import AccordionActions from '@mui/material/AccordionActions';
import AccordionSummary from '@mui/material/AccordionSummary';
import AccordionDetails from '@mui/material/AccordionDetails';
import Typography from '@mui/material/Typography';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import Button from '@mui/material/Button';
import CircularProgress from '@mui/material/CircularProgress';
import useFaq from "../hooks/useFaq";




const FAQ = () => {
    const { faqData, loading, error } = useFaq();

    return (
        <div>
            <div className="faq-page-banner">
                <Label label="FAQ" fontSize="128px" fontWeight="700" color="#FFFFFF" />
                <div className="faq-page-banner-social" >
                    <Label label="Frequently asked questions" fontSize="25px" fontWeight="700" color="#FFFFFF" />
                    <Label label="Find Answer to all your questions here !" fontSize="16px" fontWeight="400" color="#FFFFFF" />
                    <div className="faq-page-banner-social-icons">
                    <img src={ic_fb} alt="faq-page-banner" />
                    <img src={ic_insta} alt="faq-page-banner" />
                    <img src={ic_linkedin} alt="faq-page-banner" />
                    <img src={ic_youtube} alt="faq-page-banner" />
                    </div>
                </div>
            </div>

            <div style={{ padding: "0 80px", marginTop: "40px", marginBottom: "40px" }}>
                {loading ? (
                    <div style={{ 
                        display: 'flex', 
                        justifyContent: 'center', 
                        alignItems: 'center',
                        minHeight: '500px'
                    }}>
                        <CircularProgress />
                    </div>
                ) : error ? (
                    <Typography color="error">{error}</Typography>
                ) : (
                    faqData.map((faq) => (
                        <div style={{ marginBottom: "20px" }}>
                        <Accordion key={faq.questionId}>
                            <AccordionSummary
                                expandIcon={<ExpandMoreIcon />}
                                aria-controls={`${faq.questionId}-content`}
                                id={`${faq.questionId}-header`}
                                sx={{
                                    backgroundColor: 'white',
                                    boxShadow: '0px 4px 20px rgba(0, 0, 0, 0.1)',
                                    borderRadius: '8px',
                                    '& .MuiAccordionSummary-content': {
                                        margin: '16px 0',
                                    }
                                }}
                            >
                                <Typography 
                                    component="span" 
                                    sx={{ 
                                        color: '#2141E5',
                                        fontSize: '16px',
                                        fontWeight: '700'
                                    }}
                                >
                                    {faq.question}
                                </Typography>
                            </AccordionSummary>
                            <AccordionDetails
                                sx={{
                                    padding: '20px',
                                    backgroundColor: 'white',
                                    borderTop: '1px solid rgba(0, 0, 0, 0.12)'
                                }}
                            >
                                <Typography
                                    sx={{
                                        textAlign: 'left',
                                        color: '#333333',
                                        fontSize: '16px'
                                    }}
                                >
                                    {faq.answer}
                                </Typography>
                            </AccordionDetails>
                        </Accordion>
                        </div>
                    ))
                )}
            </div>

            <Footer />
        </div>
    );
};

export default FAQ;